import { render, staticRenderFns } from "./DeliveryHowItWorksLine01.vue?vue&type=template&id=6ffe60d2&"
import script from "./DeliveryHowItWorksLine01.vue?vue&type=script&lang=js&"
export * from "./DeliveryHowItWorksLine01.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports